import {memo} from 'react';

type Props = {
  filterId: string;
  radius?: number;
};

const RoundedCornersFilter = ({filterId, radius = 16}: Props) => {
  return (
    <svg className="hidden" width="0" height="0">
      <title>Rounded corners mask</title>
      <defs>
        <filter id={filterId}>
          <feGaussianBlur in="SourceGraphic" stdDeviation={radius} result="blur-sm" />

          <feColorMatrix
            in="blur-sm"
            mode="matrix"
            values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 100 -50"
            result="mask"
          />

          <feComposite in="SourceGraphic" in2="mask" operator="atop" />
        </filter>
      </defs>
    </svg>
  );
};

export default memo(RoundedCornersFilter);
